import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";

const DoctorTranscriptionSection = ({ transcript, setTranscript }) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      className="transcription flex flex-col items-center justify-center py-12"
    >
      {/* <h2 className="text-2xl font-semibold text-indigo-800 mb-6 flex items-center">
        <FontAwesomeIcon icon={faFileAlt} className="mr-3 text-indigo-500" />
        Transcription
      </h2> */}
      <textarea
        className="w-full max-w-3xl h-72 p-6  rounded-2xl shadow-xl focus:outline-none bg-white text-l"
        placeholder="Transcription will appear here"
        value={transcript}
        onChange={(e) => setTranscript(e.target.value)}
      />
    </motion.section>
  );
};

export default DoctorTranscriptionSection;
